"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@8base/utils");
exports.FORMAT_PATTERN = {
    [utils_1.TEXT_FORMATS.UNFORMATTED]: /.*/,
    [utils_1.TEXT_FORMATS.NAME]: /.*/,
    [utils_1.SMART_FORMATS.ADDRESS]: /.*/,
    [utils_1.TEXT_FORMATS.EMAIL]: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    [utils_1.TEXT_FORMATS.PHONE]: /^(0|[1-9][0-9]{9})$/i,
    [utils_1.TEXT_FORMATS.SSN]: /^(?!666|000|9\d{2})\d{3}[- ]{0,1}(?!00)\d{2}[- ]{0,1}(?!0{4})\d{4}$/,
    [utils_1.TEXT_FORMATS.EIN]: /^\d{2}[- ]{0,1}\d{7}$/,
    [utils_1.DATE_FORMATS.DATE]: /\d{4}-[01]\d-[0-3]\d/,
    [utils_1.DATE_FORMATS.DATETIME]: /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/,
};
exports.VALIDATION_ERROR = {
    [utils_1.DATE_FORMATS.DATE]: () => 'Invalid date.',
    [utils_1.DATE_FORMATS.DATETIME]: () => 'Invalid datetime.',
    [utils_1.SMART_FORMATS.ADDRESS]: () => '',
    [utils_1.TEXT_FORMATS.EIN]: () => 'Invalid Employer Identification Number.',
    [utils_1.TEXT_FORMATS.EMAIL]: () => 'Invalid email.',
    [utils_1.TEXT_FORMATS.NAME]: () => '',
    [utils_1.TEXT_FORMATS.PHONE]: () => 'Invalid phone number.',
    [utils_1.TEXT_FORMATS.SSN]: () => 'Invalid Social Security Number.',
    [utils_1.TEXT_FORMATS.UNFORMATTED]: () => '',
    FORMAT: (format) => `Value doesn't match ${format} format.`,
    IS_REQUIRED: () => 'Value is required',
    MAX_FIELD_SIZE: (maxFieldSize) => `Maximum allowed field size is ${maxFieldSize}. It was exceeded.`,
    MAX_PRECISION: (maxPrecision) => `Maximum allowed precision is ${maxPrecision}. It was exceeded.`,
    MAX_VALUE: (maxValue) => `Value is greater than maximum allowed value ${maxValue}.`,
    MIN_VALUE: (minValue) => `Value is lower than minimum allowed value ${minValue}.`,
    NOT_A_JSON: (parseError) => `Value isn't a valid JSON: ${parseError}.`,
    NOT_A_NUMBER: () => `Value isn't a number`,
};
//# sourceMappingURL=validator.constants.js.map